export default __webpack_public_path__ + "static/media/Awesome_Lock.000a6a73.svg";